module.exports = __webpack_public_path__ + "img/266.34fcb3a6.png";